import { getRootElement } from './root';

/**
 * @param {string} routeName
 */
function normalizeRouteName(routeName) {
  if (!routeName) {
    return routeName;
  }

  // Accept legacy demo names and the prefixed filenames emitted by MVC.
  const fileName = routeName.replace(/\.json-reverse$/, '-reverse.json');
  return fileName.startsWith('route-') ? fileName : `route-${fileName}`;
}

function createCruiseConfig() {
  const root = getRootElement();
  return {
    cruiseId: root?.dataset?.cruiseId ?? '',
    cruiseYear: root?.dataset?.cruiseYear ?? '',
    cruiseReverse: root?.dataset?.cruiseReverse ?? '',
    routesBaseUrl: root?.dataset?.routesBaseUrl ?? import.meta.env.BASE_URL,
    routeName: normalizeRouteName(root?.dataset?.routeName ?? ''),
    overviewUrl: root?.dataset?.overviewUrl ?? '',
  };
}

export const cruiseConfig = createCruiseConfig();
